"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewResetToken extends new_item_1.default {
    constructor(newResetToken) {
        super();
        this.emailAddress = newResetToken.emailAddress;
        this.status = newResetToken.status;
        this.token = newResetToken.token;
        this.password = newResetToken.password;
    }
}
exports.default = NewResetToken;
//# sourceMappingURL=new-resetToken.js.map